export type ShareResult = 'shared' | 'copied' | 'cancelled' | 'failed';

// Web Share API works inside Capacitor's Android/iOS WebViews and on most mobile
// browsers — it triggers the OS share sheet. On desktops it's spotty, so we
// fall back to clipboard. Returning a discriminated result lets callers show a
// snackbar only for the clipboard path (the OS sheet is its own confirmation).
export const sharePlaylistLink = async ({title, url}: {title: string; url: string}): Promise<ShareResult> => {
    if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        try {
            await navigator.share({title, url});
            return 'shared';
        } catch (e) {
            if (e instanceof Error && e.name === 'AbortError') return 'cancelled';
            // Other failures (permission denied, share unavailable for this content): fall through to clipboard.
        }
    }
    try {
        await navigator.clipboard.writeText(url);
        return 'copied';
    } catch {
        return 'failed';
    }
};
